import React, { useEffect, useState } from 'react'
import OtpInput from 'react-otp-input';
import Header from '../../components/common/header/Header';
import Footer from '../../components/common/footer/Footer';
import { useLocation, useNavigate } from "react-router-dom";
import { User_Otp_Verify, Send_Pooja_Complete_Otp } from '../../api/auth_api/Auth_Api';
import { toast } from 'react-toastify';
import { User_Authentication } from '../../user_authentication/User_Authentication';

import { requestPermission } from '../../firebase/Firebase';
import { get_Page_Seo } from '../../api/global/Global';
import { Helmet } from 'react-helmet';
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../config/Config';
import Astrologer_after_Login_Header from '../../components/pages/astrologer/astrologer_after_login_header/Astrologer_after_Login_Header';

const OTP_TIMEOUT = 5 * 60; // 5 minutes in seconds

const Pooja_Complete_Otp_Verify = () => {
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [otp, setOtp] = useState('');
    const [otpError, setOtpError] = useState(false);
    const [otpTimer, setOtpTimer] = useState(OTP_TIMEOUT);
    const [otpExpired, setOtpExpired] = useState(false);

    const [resendTimer, setResendTimer] = useState(300);
    const [invalidAttempts, setInvalidAttempts] = useState(0);
    const [cooldownTimer, setCooldownTimer] = useState(0);

    // Extracting passed parameters from the navigation state
    const location = useLocation();
    const { mobile, country_code, id, user_id } = location.state || {};

    // <-------------- Timers & Cooldown Logic --------------->
    useEffect(() => {
        if (mobile) {
            // Store user_id if present
            if (user_id) {
                localStorage.setItem(`otp_user_id_pooja_${mobile}`, user_id);
            }

            // Load invalid attempts
            const savedAttempts = localStorage.getItem(`otp_attempts_pooja_${mobile}`);
            if (savedAttempts) {
                setInvalidAttempts(parseInt(savedAttempts, 10));
            } else {
                setInvalidAttempts(0);
            }

            // Load cooldown timer
            const cooldownUntil = localStorage.getItem(`otp_cooldown_until_pooja_${mobile}`);
            if (cooldownUntil) {
                const remaining = Math.ceil((parseInt(cooldownUntil, 10) - Date.now()) / 1000);
                if (remaining > 0) {
                    setCooldownTimer(remaining);
                } else {
                    setCooldownTimer(0);
                    localStorage.removeItem(`otp_cooldown_until_pooja_${mobile}`);
                    localStorage.removeItem(`otp_attempts_pooja_${mobile}`);
                    setInvalidAttempts(0);
                }
            } else {
                setCooldownTimer(0);
            }

            // Load resend timer
            const resendUntil = localStorage.getItem(`otp_resend_until_pooja_${mobile}`);
            if (resendUntil) {
                const remaining = Math.ceil((parseInt(resendUntil, 10) - Date.now()) / 1000);
                if (remaining > 0) {
                    setResendTimer(remaining);
                } else {
                    setResendTimer(0);
                }
            } else {
                const resendUntilTime = Date.now() + 300 * 1000;
                localStorage.setItem(`otp_resend_until_pooja_${mobile}`, resendUntilTime);
                setResendTimer(300);
            }

            // Load OTP session timer
            const otpSessionUntil = localStorage.getItem(`otp_session_until_pooja_${mobile}`);
            if (otpSessionUntil) {
                const remaining = Math.ceil((parseInt(otpSessionUntil, 10) - Date.now()) / 1000);
                if (remaining > 0) {
                    setOtpTimer(remaining);
                } else {
                    setOtpExpired(true);
                    setOtpTimer(0);
                }
            } else {
                const sessionTime = Date.now() + OTP_TIMEOUT * 1000;
                localStorage.setItem(`otp_session_until_pooja_${mobile}`, sessionTime);
                setOtpTimer(OTP_TIMEOUT);
                setOtpExpired(false);
            }
        }
    }, [mobile, user_id]);

    // Session countdown timer
    useEffect(() => {
        if (otpTimer > 0) {
            const timer = setInterval(() => {
                setOtpTimer(prev => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        setOtpExpired(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [otpTimer]);

    // Resend countdown timer
    useEffect(() => {
        if (mobile && resendTimer > 0) {
            const timer = setInterval(() => {
                setResendTimer(prev => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        localStorage.removeItem(`otp_resend_until_pooja_${mobile}`);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [resendTimer, mobile]);

    // Cooldown countdown timer
    useEffect(() => {
        if (mobile && cooldownTimer > 0) {
            const timer = setInterval(() => {
                setCooldownTimer(prev => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        localStorage.removeItem(`otp_cooldown_until_pooja_${mobile}`);
                        localStorage.removeItem(`otp_attempts_pooja_${mobile}`);
                        setInvalidAttempts(0);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [cooldownTimer, mobile]);

    // Redirect when expired
    useEffect(() => {
        if (otpExpired) {
            toast.error("OTP session expired. Please request a new OTP.");
            navigate("/pandit-pooja-complete-list");
        }
    }, [otpExpired, navigate]);

    const formatTimer = (seconds) => {
        const m = String(Math.floor(seconds / 60)).padStart(2, '0');
        const s = String(seconds % 60).padStart(2, '0');
        return `${m}:${s}`;
    };

    const Handle_User_Login_Otp_Verify = async (e) => {
        e.preventDefault();

        if (cooldownTimer > 0) {
            toast.error("Too many attempts. please try again later");
            return;
        }

        if (otpExpired) {
            toast.error("OTP session expired. Please request a new OTP.");
            navigate("/pandit-pooja-complete-list");
            return;
        }
        setIsLoading(true);

        // Check if the OTP is valid (4 digits long)
        if (otp.length !== 4) {
            setOtpError(true);
            setIsLoading(false);
            toast.error("Please enter a valid 4-digit OTP.");
            return;
        }

        try {
            const otp_verify_data = {
                otp,
                type: "pooja",
                country_code,
                mobile,
                pooja_id: id,
            };

            const response = await User_Otp_Verify(otp_verify_data);

            if (response?.data?.status == "200") {
                setIsLoading(false);
                toast.success(response?.data?.message);
                
                // Clear localStorage
                localStorage.removeItem(`otp_attempts_pooja_${mobile}`);
                localStorage.removeItem(`otp_cooldown_until_pooja_${mobile}`);
                localStorage.removeItem(`otp_resend_until_pooja_${mobile}`);
                localStorage.removeItem(`otp_session_until_pooja_${mobile}`);
                localStorage.removeItem(`otp_user_id_pooja_${mobile}`);

                navigate('/pandit-pooja-complete-list')
            } else {
                setIsLoading(false);
                toast.error(response?.response?.data?.message || response?.data?.message || "Invalid OTP");

                const newAttempts = invalidAttempts + 1;
                setInvalidAttempts(newAttempts);
                localStorage.setItem(`otp_attempts_pooja_${mobile}`, newAttempts);

                if (newAttempts >= 4) {
                    localStorage.setItem(`otp_cooldown_until_pooja_${mobile}`, Date.now() + 5 * 60 * 1000);
                    setCooldownTimer(300);
                    toast.error("Too many invalid attempts. Cooldown started for 5 minutes.");
                }
            }
        } catch (error) {
            setIsLoading(false);
            console.error("Error during OTP verification:", error);
            
            const newAttempts = invalidAttempts + 1;
            setInvalidAttempts(newAttempts);
            localStorage.setItem(`otp_attempts_pooja_${mobile}`, newAttempts);

            if (newAttempts >= 4) {
                localStorage.setItem(`otp_cooldown_until_pooja_${mobile}`, Date.now() + 5 * 60 * 1000);
                setCooldownTimer(300);
                toast.error("Too many invalid attempts. Cooldown started for 5 minutes.");
            }
        }
    };

    const Handle_Resend_Otp = async () => {
        if (resendTimer > 0 || cooldownTimer > 0) return;

        setIsLoading(true);
        try {
            const token = User_Authentication();
            if (!token) {
                setIsLoading(false);
                toast.error("User token not found. Please log in again.");
                return;
            }

            // Retrieve current user_id from props/state or fallback to localStorage
            let currentUserId = user_id || localStorage.getItem(`otp_user_id_pooja_${mobile}`);
            if (!currentUserId) {
                setIsLoading(false);
                toast.error("User ID not found. Unable to resend OTP.");
                return;
            }

            const response = await Send_Pooja_Complete_Otp(
                { user_id: currentUserId },
                { Authorization: `Bearer ${token}` }
            );

            if (response?.data?.status == 200) {
                setIsLoading(false);
                toast.success(response?.data?.message || "OTP resent successfully.");
                setOtp('');
                setOtpError(false);

                // Reset timers and attempts
                const resendUntilTime = Date.now() + 5 * 60 * 1000;
                localStorage.setItem(`otp_resend_until_pooja_${mobile}`, resendUntilTime);
                setResendTimer(300);

                const sessionTime = Date.now() + OTP_TIMEOUT * 1000;
                localStorage.setItem(`otp_session_until_pooja_${mobile}`, sessionTime);
                setOtpTimer(OTP_TIMEOUT);
                setOtpExpired(false);

                setInvalidAttempts(0);
                localStorage.removeItem(`otp_attempts_pooja_${mobile}`);
                setCooldownTimer(0);
                localStorage.removeItem(`otp_cooldown_until_pooja_${mobile}`);
            } else {
                setIsLoading(false);
                const errorMsg = response?.response?.data?.message || response?.data?.message || "Failed to resend OTP.";
                toast.error(errorMsg);
            }
        } catch (error) {
            setIsLoading(false);
            console.error("Error resending OTP:", error);
            toast.error("An error occurred. Please try again.");
        }
    };

    // Function to format the mobile number
    const formatMobileNumber = (mobile) => {
        if (!mobile || mobile.length < 10) return mobile;
        const firstTwoDigits = mobile.slice(0, 2);
        const lastTwoDigits = mobile.slice(-2);
        return `${firstTwoDigits}******${lastTwoDigits}`;
    };

    return (
        <>
            <div>
                {/* <--------- header section's ---------------> */}
                <Astrologer_after_Login_Header />
                {/* <!-- OTP --> */}
                <section className="gi-register bg-[#F0F4F8] py-[40px] max-[767px]:py-[30px] min-h-screen w-full">
                    <div id="hideLink" className="w-full">
                        {
                            isLoading ? (
                                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                                    <div className="w-16 h-16 border-t-4 border-white border-solid rounded-full animate-spin"></div>
                                </div>
                            ) : (
                                <div className="gi-login-box w-[50%] bg-white p-5 rounded m-auto px-[15px] max-[991px]:w-full max-[991px]:p-[0] text-center">
                                    <div className="section-title-2 w-full mb-[20px] pb-[20px]">
                                        <h2 className="gi-title mb-[0] font-Poppins text-[26px] font-semibold text-[#4b5966] relative inline p-[0] capitalize leading-[1]">
                                            Verification code
                                        </h2>
                                        <p className="mt-[15px] text-[14px] text-[#777] leading-[23px]">
                                            We have sent the verification code on your mobile number
                                            <span className="font-bold text-black"> {country_code}{formatMobileNumber(mobile)}</span>
                                        </p>
                                    </div>
                                    <div className="gi-login-wrapper my-[0] mx-auto">
                                        <div className="gi-login-container">
                                            <div className="gi-login-form">
                                                <form method="post" className="flex flex-col" onSubmit={Handle_User_Login_Otp_Verify}>

                                                    <div className="gi-login-wrap flex-col">
                                                        {/* OTP Input Fields */}
                                                        <div className="otp-input-fields w-full flex justify-center gap-[10px] mb-[20px]">
                                                            <OtpInput
                                                                value={otp}
                                                                onChange={(newOtp) => {
                                                                    if (/^\d*$/.test(newOtp)) { // Ensure only numbers are allowed
                                                                        setOtp(newOtp);
                                                                        if (newOtp.length === 4) {
                                                                            setOtpError(false);
                                                                        }
                                                                    }
                                                                }}
                                                                numInputs={4}
                                                                shouldAutoFocus
                                                                isDisabled={cooldownTimer > 0}
                                                                renderInput={(props) => (
                                                                    <input
                                                                        {...props}
                                                                        type="number"
                                                                        className="otp__digit otp__field__1 rounded-[50%] border-[1px] border-[#ddd] p-[0] 
                                                                                   text-center text-[16px] text-[#333] focus:outline-none"
                                                                        style={{ width: "40px", height: "40px" }}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                        {otpError && <span className="text-red-500 text-sm">Please enter a valid OTP.</span>}
                                                    </div>

                                                    <div className="text-center mb-[15px]">
                                                        {cooldownTimer > 0 ? (
                                                            <span className="text-[14px] text-red-500 font-medium">
                                                                Too many attempts. Try again in {formatTimer(cooldownTimer)}
                                                            </span>
                                                        ) : (
                                                            <span className="text-[14px] text-[#777]">
                                                                {resendTimer > 0 ? `Resend OTP in ${formatTimer(resendTimer)}` : ""}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <button
                                                        type="button"
                                                        onClick={Handle_Resend_Otp}
                                                        disabled={resendTimer > 0 || cooldownTimer > 0}
                                                        className={`w-full mb-[10px] block p-[14px] text-center rounded-[5px] text-[16px] outline-[0] h-[50px] ${resendTimer > 0 || cooldownTimer > 0
                                                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                                            : "text-[#fff] bg-gradient-to-r from-[#9F2225] to-[#FFB500]"
                                                            }`}
                                                    >
                                                        Resend OTP
                                                    </button>

                                                    <button
                                                        type="submit"
                                                        disabled={cooldownTimer > 0}
                                                        className={`w-full mt-[20px] block p-[14px] text-center text-[#fff] rounded-[5px] text-[16px] outline-[0] h-[50px] ${cooldownTimer > 0
                                                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                                            : "bg-gradient-to-r from-[#9F2225] to-[#FFB500]"
                                                            }`}
                                                    >
                                                        Submit
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            )
                        }
                    </div>
                </section>
                {/* <---------- Footer section's --------------> */}
                <Footer />

            </div>
        </>
    )
}

export default Pooja_Complete_Otp_Verify;